import React from 'react';

const About = () => {
  const values = [
    {
      icon: 'fa-handshake',
      title: 'Amanah',
      description: 'Menjalankan bisnis dengan prinsip kejujuran dan transparansi',
      bgColor: 'bg-primary'
    },
    {
      icon: 'fa-award',
      title: 'Kualitas',
      description: 'Mengutamakan kualitas produk dan layanan terbaik',
      bgColor: 'bg-secondary'
    },
    {
      icon: 'fa-leaf',
      title: 'Berkelanjutan',
      description: 'Mendukung praktik pertanian yang ramah lingkungan',
      bgColor: 'bg-accent',
      textColor: 'text-primary'
    },
    {
      icon: 'fa-users',
      title: 'Kolaboratif',
      description: 'Membangun kemitraan yang saling menguntungkan',
      bgColor: 'bg-primary'
    }
  ];

  return (
    <section id="tentang" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-primary/10 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-info-circle mr-2"></i>
            Tentang Kami
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Membangun Ekosistem<br className="hidden sm:block"/>
            <span className="text-secondary">Pertanian Berkelanjutan</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-1">
            PAK MoO didirikan dengan visi menciptakan ekosistem pertanian yang berkelanjutan, 
            memberdayakan petani lokal, dan menyediakan produk berkualitas tinggi untuk masyarakat.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16 lg:mb-20">
          <div>
            <img className="w-full h-64 sm:h-80 md:h-[420px] lg:h-[500px] object-cover rounded-2xl shadow-xl" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/7ed83f3d21-01f62baea0b1093384f6.png" alt="Indonesian farmers working together in organic farm, community spirit, natural environment" />
          </div>
          <div className="space-y-8">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-primary mb-3 sm:mb-4">Sejarah Kami</h3>
              <p className="text-gray-600 leading-relaxed mb-5 sm:mb-6 text-sm sm:text-base">
                Dimulai dari keprihatinan terhadap kondisi petani dan peternak lokal, PAK MoO hadir sebagai jembatan 
                antara produsen dan konsumen. Kami berkomitmen untuk menciptakan nilai tambah bagi semua pihak 
                dalam rantai nilai pertanian.
              </p>
              <div className="grid grid-cols-2 gap-3 sm:gap-4">
                <div className="bg-light-bg p-4 rounded-xl text-center sm:text-left">
                  <div className="text-xl sm:text-2xl font-bold text-primary">2018</div>
                  <div className="text-xs sm:text-sm text-gray-600">Tahun Berdiri</div>
                </div>
                <div className="bg-light-bg p-4 rounded-xl text-center sm:text-left">
                  <div className="text-xl sm:text-2xl font-bold text-primary">6+</div>
                  <div className="text-xs sm:text-sm text-gray-600">Tahun Pengalaman</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center p-6 sm:p-7 bg-light-bg rounded-2xl hover:shadow-lg transition-shadow">
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${value.bgColor} ${value.textColor || 'text-white'} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`fa-solid ${value.icon} text-xl sm:text-2xl`}></i>
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-primary mb-2 sm:mb-3">{value.title}</h4>
              <p className="text-gray-600 text-sm sm:text-base">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;

